import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Select,
  Stack,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import SubscriptionsHtmlTable from "./TiersHtmlTable";
import SearchBar from "../../../components/SearchBar";


const rows = [
  {
    id: 1,
    module: "Vendors",
    lowLevel: "Level 1",
    mediumStatus: "Connected",
    impact: "50%",
    guardrail: "Manual",
  },
  {
    id: 2,
    module: "Pricing Engine",
    lowLevel: "Level 2",
    mediumStatus: "Connected",
    impact: "50%",
    guardrail: "Reg",
  },
  {
    id: 3,
    module: "Listings",
    lowLevel: "Level 2",
    mediumStatus: "Connected",
    impact: "30%",
    guardrail: "Reg",
  },
  {
    id: 4,
    module: "Marketing",
    lowLevel: "Level 1",
    mediumStatus: "Recommended",
    impact: "10%",
    guardrail: "High",
  },
];

const maturityLevels = [
  {
    id: 1,
    level: "Level 1",
    title: "Recommend Only.",
    desc: "AI suggests actions only. Admin approval required to execute.",
  },
  {
    id: 2,
    level: "Level 2",
    title: "Recommend + Execute",
    desc: "AI recommends and auto-executes actions requiring medium oversight.",
  },
  {
    id: 3,
    level: "Level 3",
    title: "Fully Autonomous",
    desc: "AI acts independently. Alerts Admin and allows fallback.",
  },
];

const logs = [
  {
    id: 1,
    text: "Grow subscription set to Recommend + Execute",
    date: "3 days ago",
    user: "Jane Doe",
  },
  {
    id: 2,
    text: "Scale subscription set to Fully Autonomous",
    date: "6 days ago",
    user: "Michael L.",
  },
];



function AIAutonomy() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  const [searchTerm, setSearchTerm] = useState("");


  return (
    <>
      {/* ================= PAGE TITLE ================= */}
      <div className="main_title ai_command_page d_flex">
        <div className="lt">
          <h1>AI Autonomy & Automation Control</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            AI Autonomy & Automation Control
          </p>
        </div>
        <div className="right_s">
          <ButtonGroup aria-label="Basic button group" variant="contained">
            <Button className="auto_pilot" color="primary">
              AI Auto Pilot
            </Button>
            <Button className="off">OFF</Button>
            <Button color="error">Emergency stop</Button>
          </ButtonGroup>
        </div>
      </div>

      <Box className="custom_tabs1 mt_20">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          className="custom_tabs_links"
        >
          <Tab label="Modules" />
          <Tab label="Subscriptions" />
        </Tabs>
      </Box>
      <div className="table_flex mt_20">
        {tabIndex === 0 && (
          <div className="lt">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search..."
                  />
                </Box>
              </div>


            </div>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow sx={{ background: "#f6f6f8" }}>
                    <TableCell>Sr</TableCell>
                    <TableCell>Module</TableCell>
                    <TableCell>AI Level</TableCell>
                    <TableCell>Medium Impact</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{index + 1}</TableCell>

                      <TableCell>
                        <Typography fontWeight={500}>{row.module}</Typography>
                      </TableCell>

                      {/* LOW IMPACT */}
                      <TableCell>

                        <Select
                          value={row.lowLevel}
                          size="small"
                          sx={{
                            background: "#e3d8ff",
                            fontWeight: 500,
                            height: "32px",
                            ".MuiOutlinedInput-notchedOutline": { border: "none" }
                          }}
                        >
                          <MenuItem value="Level 1">Level 1</MenuItem>
                          <MenuItem value="Level 2">Level 2</MenuItem>
                          <MenuItem value="Level 3">Level 3</MenuItem>
                        </Select>

                      </TableCell>

                      {/* MEDIUM IMPACT */}
                      <TableCell>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{
                            background: "#e8f5f0",
                            p: 1,
                            borderRadius: 3,
                            width: "fit-content",
                          }}
                        >
                          <CheckCircleIcon fontSize="small" color="success" />
                          <Chip
                            label={row.mediumStatus}
                            size="small"
                            sx={{ background: "#d7f3e8", fontWeight: 500 }}
                          />
                          <Switch defaultChecked size="small" color="success" />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Edit</MenuItem>
                <MenuItem onClick={handleClose}>Disable</MenuItem>
                <MenuItem onClick={handleClose}>View Details</MenuItem>
              </Menu>
            </TableContainer>

          </div>
        )}

        {tabIndex === 1 && <SubscriptionsHtmlTable />}


        <div className="rt">
          <div className="right_panel">
            {/* AI AUTONOMY MATURITY */}
            <div className="maturity_card">
              <h3 className="card_title">AI Autonomy Maturity</h3>

              {maturityLevels.map((item) => (
                <div key={item.id} className="maturity_item">
                  <div className={`level_box level_${item.id}`}>{item.id}</div>
                  <div>
                    <h4>
                      {item.level} <span>{item.title}</span>
                    </h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* FILTER & RULE LOG */}
            <div className="rule_card">
              <div className="rule_header">
                <h3>Filter & Rule Log</h3>
                <Button variant="text" size="small">
                  •••
                </Button>
              </div>

              <div className="filter_row form">
                <Select size="small" defaultValue="subscription">
                  <MenuItem value="subscription">Subscription</MenuItem>
                </Select>

                <Select size="small" defaultValue="7days">
                  <MenuItem value="7days">Last 7 Days</MenuItem>
                </Select>
              </div>

              {logs.map((log) => (
                <div key={log.id} className="log_item">
                  <p>
                    <strong>{log.text.split(" ")[0]}</strong>{" "}
                    {log.text.split(" ").slice(1).join(" ")}
                  </p>
                  <span>
                    {log.date} &nbsp; {log.user}
                  </span>
                  <Button
                    variant="text"
                    size="small"
                    style={{ float: "right" }}
                  >
                    •••
                  </Button>
                </div>
              ))}

              <div
                className="view_all"
                style={{ textAlign: "right", marginTop: 10 }}
              >
                <Button variant="text" size="small" color="primary">
                  View All
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AIAutonomy;
